export const vidrisCategorical: string[] = [];
export const vidrisCategoricalMixed: string[] = [];
